export const PATH_SEPARATOR = "/";
export const PARAM_IDENTIFIER = ":";
export const ID = "id";
export const EMAIL = "email";
export const RESET_CODE = "resetCode";
export const CONFIRMATION_CODE = "confirmationCode";
export const REDIRECT_PAGE = "redirectPage";
export const POLICY = "policy";
export const REFERENCE = "ref";
export const REFERENCE_PARAM = PARAM_IDENTIFIER + REFERENCE;
export const ID_PARAM = PARAM_IDENTIFIER + ID;
